// Normal survival runs keep the existing 30-minute boss schedule, then continue until death or quitting.
// This is a boss-arrival time, not a run time limit. QA routes and named challenges may use explicit timing.
export const SURVIVAL_RUN = Object.freeze({ bossTime: 1800, endless: true as const });
